// extracted by mini-css-extract-plugin
export var currencyInput = "_n9-1";
export var currencySymbol = "_n9-0";